import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { InputSelect } from '../InputTypes/InputSelect/InputSelect';
import { checkEmptyFieldValue, getInputType, checkValidAttachmentField } from '../../utils';
import { LoadingDots } from '../LoadingDots/LoadingDots';
import './formContent.css';
import { useTranslator } from '../../translation/hooks';
import { formatPayload } from './library';
import { useFormInfo, useFormInfoDispatch } from '../../context/states/formInfo';

export const FormContent = props => {
  const {
    fields,
    handleFormPost,
    handleFilePost,
    handleFileDelete,
    setShowToaster,
    setToasterMessage,
    setToasterType,
    isIframe,
    phoneTypes
  } = props

  const [formInfo] = useFormInfo();
  const formInfoDispatch = useFormInfoDispatch();
  const [formPayload, setFormPayload] = useState([]);
  const [errorOnForm, setErrorOnForm] = useState(false);
  const [hasRequired, setHasRequired] = useState(false);
  const [loadingFormSend, setLoadingFormSend] = useState(false);
  const [formSent, setFormSent] = useState(false);
  //Nagro
  const [contactType, setContactType] = useState(0);
  const [isFieldContact, setIsFieldContact] = useState(false);

  const submitDisabled = useMemo(
    () => loadingFormSend || formInfo.isFormDisabled || formInfo.isSendDisabled,
    [formInfo.isFormDisabled, formInfo.isSendDisabled, loadingFormSend]
  );

  const { Translation } = useTranslator();

  const ordinatedFields = useMemo(() => [...fields].sort((a,b) => a.Ordination - b.Ordination), [fields])

    useEffect(() => {
        const formPayload = buildFormPayload(ordinatedFields);
        setFormPayload(formPayload);
        setIsFieldContact(ordinatedFields.filter(obj => obj.ImportationTemplateEntityId === 1 || obj.ImportationTemplateEntityId === 2).length > 0); //Nagro
    }, [ordinatedFields])

  const handleShowErrorToaster = useCallback(() => {
    setShowToaster(true);
    setToasterMessage(Translation('GENERICS.TOASTER.FORM_ERROR'));
    setToasterType('ERROR');

    setTimeout(() => {
      setShowToaster(false);
    }, 5000);
  }, [Translation, setShowToaster, setToasterMessage, setToasterType]);

    const buildFormPayload = fields => {
        const tempFormPayload = [];
        let hasOneRequired = false;
        fields.forEach(field => {
            const payloadObject = {};
            payloadObject[field.ObjectKey] = '';
            payloadObject.required = field.Required;
            tempFormPayload.push(payloadObject);
            if (field.Required) hasOneRequired = true;
        });

        setHasRequired(hasOneRequired);

        return [...tempFormPayload];
    }

  const onInputChange = useCallback((value, index, key, required, isValid, errorMessage) => {
    const payloadItem = {};
    payloadItem[key] = value;
    payloadItem.required = required;
    if (typeof isValid === 'boolean') {
      payloadItem.isValid = isValid;
      payloadItem.errorMessage = errorMessage;
    }
    setFormPayload([
      ...formPayload.slice(0, index),
      { ...payloadItem },   
      ...formPayload.slice(index + 1),
    ])
  }, [formPayload]);

  const onTypeInputChange = (value) => { //Nagro
    if (value) {
        if (value == 'PJ') {
            setContactType(1)
        } else {
            setContactType(2)
        }
    }else{
        setContactType(0)
    }
  };

  const onClickSubmit = useCallback( async e => {
    e.preventDefault();

    if (contactType == 0 && isFieldContact) { //Nagro
      setErrorOnForm(true);
      formInfoDispatch({...formInfo, isFormDisabled: false, isSendDisabled: false});
      return handleShowErrorToaster();
    }

    setLoadingFormSend(true);
    formInfoDispatch({...formInfo, isFormDisabled: true, isSendDisabled: true});

    try {
      const { data, hasErrorOnForm } = formatPayload({
        payload: formPayload,
        ordinatedFields,
      });

      setErrorOnForm(hasErrorOnForm);

      if (hasErrorOnForm) {
        formInfoDispatch({...formInfo, isFormDisabled: false, isSendDisabled: false});
        return handleShowErrorToaster();
      }

      await handleFormPost(data);
      setFormSent(true);
    } catch (error){
      console.log(error);
      formInfoDispatch({...formInfo, isFormDisabled: false, isSendDisabled: false});
    } finally {
      setLoadingFormSend(false);
    }

  }, [formInfoDispatch, formInfo, formPayload, ordinatedFields, handleFormPost, handleShowErrorToaster]);

  const getInput = (fieldValue, field, index) => {
    if (field.FieldKey === 'contact_foreign_zipcode') {
      const countryFieldIndex = ordinatedFields.findIndex((f) => f.FieldKey === 'contact_zipcode_country');
      if (countryFieldIndex === -1) return getInputType(fieldValue, onInputChange, field, index, phoneTypes);
  
      const countryField = ordinatedFields[countryFieldIndex];
      return getInputType(fieldValue, onInputChange, field, index, phoneTypes, { index: countryFieldIndex, field: countryField });
    }

    return getInputType(fieldValue, onInputChange, field, index, phoneTypes, undefined, handleFilePost, handleFileDelete);
  }

  //Nagro
  const typeOfCustomer = new Object();
  const fieldProperties = new Object();
  fieldProperties.Multiple = false;

  const Options = new Array();

  var Option = new Object();
  Option.Name = "PF";
  Option.Ordination = 0;
  Options.push(Option);

  Option = new Object();
  Option.Name = "PJ";
  Option.Ordination = 1;
  Options.push(Option);

  typeOfCustomer.Options = Options;
  typeOfCustomer.Field = fieldProperties;

  return (
    <form className={`form-content ${isIframe ? '--zero-padding --no-container' : ''}`}>
      { isFieldContact && <div className='form-content__item' >
          <label htmlFor='name' className='form-content__label'>Tipo de cliente*</label>
          <div className='form-content__desc'></div>
          {errorOnForm && contactType === 0 &&
              <div className='form-content__validation'>Campo obrigatório não preenchido</div>
          }                
            <InputSelect field={typeOfCustomer} index={0} setValue={onTypeInputChange} />
          </div>
      }
      {ordinatedFields.map((field, index) => {
        if (field.FieldKey === 'contact_zipcode_country') return <></>;
        const canShowSelect = field.Options.length > 0 || (field.Field?.TypeId === 7 && field.Field?.SecondaryEntityId === 25);
        const fieldValue = formPayload[index] ? formPayload[index][field.ObjectKey] : '';
        const customErrorMessage = formPayload[index] ? formPayload[index].errorMessage : '';
        const isValid = formPayload[index] ? formPayload[index].isValid : '';
        const invalidAttachments = checkValidAttachmentField(fieldValue, field);
        //Nagro
        const notContactField = field.ImportationTemplateEntityId != 1 && field.ImportationTemplateEntityId != 2
        const fieldTypeEqualContactType = (contactType == 1 && field.ImportationTemplateEntityId === 1) || (contactType == 2 && field.ImportationTemplateEntityId === 2)
        field.mustShowField = fieldTypeEqualContactType;

        if(fieldTypeEqualContactType || notContactField) {
          return (
            <div className='form-content__item' key={index}>
              <label htmlFor='name' className='form-content__label'>{field.Label}{field.Required && '*'}</label>
              <div className='form-content__desc'>{field.Description}</div>
              {errorOnForm && checkEmptyFieldValue(formPayload[index][field.ObjectKey]) && field.Required &&
                <div className='form-content__validation'>
                  { Translation('FIELDS.REQUIRED_EMPTY') }
                </div>
              }
              {errorOnForm && invalidAttachments?.length > 0 &&
                <div className='form-content__validation'>{field.Label} com extensões "{invalidAttachments.toString()}" inválidas. </div>
              }
              {errorOnForm && !isValid && customErrorMessage &&
                <div className='form-content__validation'>
                  { customErrorMessage }
                </div>
              }
              {canShowSelect
                ? <InputSelect field={field} index={index} setValue={onInputChange} />
                : <>{getInput(fieldValue, field, index)}</>
              }
            </div>
          )
        }
      })}
      <div className='form-content__item'>
        <button onClick={onClickSubmit}
          disabled={submitDisabled}
          className={`form-content__button ${submitDisabled? '--disabled' : ''}`}
        >
          {loadingFormSend ? <LoadingDots /> : (formSent ? Translation('GENERICS.TOASTER.FORM_SUCCESS') : Translation('GENERICS.SEND'))}
        </button>
        {hasRequired && <p className='form-content__desc'>* { Translation('FIELDS.REQUIRED') }</p>}
      </div>
    </form>
  )
}